import React, { type ReactElement } from 'react';

const CertsyBrand = (): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 207.33 59.59">
    <title>Certsy brand image</title>
    <g id="Layer_2" data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="#1d1d2f"
          d="M86,21.87a3.55,3.55,0,0,1-1.12,1.2,8.06,8.06,0,0,0-5.46-1.77c-4.74,0-6.8,3.79-6.8,8.46s2.42,8.5,6.76,8.5A7.27,7.27,0,0,0,83.75,37c.54-.36,1.12-.65,1.63.25l.94,1.67c.32.54.58,1-.08,1.55a11.24,11.24,0,0,1-6.94,2c-7.77,0-11.61-5.42-11.57-12.66s3.76-12.65,11.46-12.65c3.91,0,5.93,1.19,6.62,1.7S87.18,20.21,86,21.87Z"
        />
        <path
          fill="#1d1d2f"
          d="M95.38,17.5h13c1.26,0,1.48.61,1.48,1.55v1.27c0,1-.51,1.41-1.56,1.37H98.78l0,6.3c2.67,0,7.3,0,8.17,0a1.07,1.07,0,0,1,1.23,1.16v1.44c0,.94-.29,1.12-1.12,1.12-1,0-5.53,0-8.28,0,0,2.35,0,4.34.07,6.22,2.75,0,8.43,0,9.51-.1s1.52.43,1.52,1.44v1.7c0,.94-.22,1.16-1.48,1.16H95.53c-1.67,0-1.7-1.48-1.67-2.6.08-2.86-.07-18.23-.07-19.06C93.76,19.2,93.18,17.5,95.38,17.5Z"
        />
        <path
          fill="1d1d2f"
          d="M130.85,33l3.54,4.62a7.33,7.33,0,0,0,2.24,2.22A2.52,2.52,0,0,1,134,42.45c-2.06,0-2.86-1.05-3.69-2.42l-4.09-6.22h-4c0,.9-.11,5.2,0,6.22.11,1.55-.29,2.06-1.52,2.06h-1.8c-1.67,0-1.7-1.48-1.67-2.6.07-2.86.11-18.23.07-19.1,0-1.23-.32-2.89,1.89-2.89h7.44c6.15,0,9.41,3.4,9.33,8.28A7.59,7.59,0,0,1,130.85,33Zm-4.52-11.9h-4.27c-.07,2.06,0,8,0,9.36h4.23c2.83,0,4.74-1.62,4.74-4.66A4.4,4.4,0,0,0,126.33,21.08Z"
        />
        <path
          fill="#1d1d2f"
          d="M160.21,19l0,1.55c0,.94-.18,1.16-1.45,1.16l-5.89,0c-.18,5-.07,16.67-.07,17.39,0,1.23.65,2.93-1.56,2.93h-1.84c-1.67,0-1.74-1.45-1.7-2.57s.22-13.67.18-17.79c-1.09,0-5.28,0-5.79,0-1.05.11-1.37-.4-1.37-1.41l0-1.66c0-.94.18-1.16,1.44-1.16,0,0,14.68.14,16.74,0C160,17.39,160.24,18,160.21,19Z"
        />
        <path
          fill="#1d1d2f"
          d="M176.29,28.13c4.63,1.27,6.18,3.58,6.26,6.73.1,4.81-4,7.59-9.44,7.59a15.47,15.47,0,0,1-6.33-1.23A2.25,2.25,0,0,1,165.44,38a3.29,3.29,0,0,1,1.09-1.59,10.41,10.41,0,0,0,6.47,2c2.78,0,4.52-1.38,4.48-3.4,0-1.45-1.3-2.53-3.79-3.15l-3.11-.79c-3.22-.84-5.83-2.57-5.9-6.4-.07-4.42,3.4-7.56,8.86-7.56a13.78,13.78,0,0,1,6.4,1.34c1.23.65,1.74,1.48,1,3.18A4.49,4.49,0,0,1,180,23a12.57,12.57,0,0,0-6.29-1.81c-2.75,0-4.08,1.38-4.08,3.33,0,1.63,1.73,2.31,3.58,2.82Z"
        />
        <path
          fill="#1d1d2f"
          d="M194.15,32.11c-1.27-2.39-6.91-11.86-7.49-12.73-.29-.51-.72-1.88.76-1.88h2.32c1.23,0,1.55.87,1.88,1.52,1,2,3.94,7.12,4.95,9h.22c1.19-2,4.63-8.13,5.1-9.26.32-.79.68-1.26,2.24-1.26h2.1a1.19,1.19,0,0,1,.9,1.88c-.83,1.23-6.8,11-8,12.84,0,1.08,0,6,.07,6.94.08,1.23.66,2.93-1.55,2.93h-1.81c-1.7,0-1.77-1.48-1.7-2.6C194.11,38,194.15,33.12,194.15,32.11Z"
        />
        <path
          fill="#4c459c"
          d="M2.3,13.21,24.12.62a4.56,4.56,0,0,1,4.6,0L50.53,13.21a4.6,4.6,0,0,1,2.31,4V42.39a4.62,4.62,0,0,1-2.31,4L28.72,59a4.61,4.61,0,0,1-4.6,0L2.3,46.38a4.63,4.63,0,0,1-2.3-4V17.2A4.61,4.61,0,0,1,2.3,13.21Z"
        />
        <path
          fill="#fff"
          d="M41.13,20.68,26.82,12.42a.27.27,0,0,0-.4.23V35.7l15.23-5.53V21.59A1.05,1.05,0,0,0,41.13,20.68Z"
        />
        <path
          fill="#00b5a9"
          d="M.83,45A4.55,4.55,0,0,0,2.3,46.38L24.12,59a4.58,4.58,0,0,0,4.6,0L41.65,51.5V30.17Z"
        />
      </g>
    </g>
  </svg>
);

export default CertsyBrand;
